import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { TimerV2 } from '../TimerV2';
import styles from './DiscountBlock.css';

function DiscountBlock({ expiryTimestamp, isExpired, onExpirePromo, title = 'Your promo code is applied!', hasTimer = true }) {
    if (!expiryTimestamp || isExpired) {
        return null;
    }

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <Icon name='discountTag' className={styles.icon} />
                <p className={styles.title}>{title}</p>
            </div>
            <div className={styles.divider} />
            <div className={styles.footer}>
                <div className={styles.code}>
                    <Icon name='checkTick' className={styles.checkIcon} />
                    <span>welcome26</span>
                </div>
                {hasTimer && (
                    <div className={styles.timer}>
                        <TimerV2
                            expiryTimestamp={expiryTimestamp}
                            onExpire={onExpirePromo}
                            minutesLabel='minutes'
                            secondsLabel='seconds'
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

DiscountBlock.propTypes = {
    expiryTimestamp: PropTypes.any,
    isExpired: PropTypes.bool,
    onExpirePromo: PropTypes.func,
    title: PropTypes.string,
    hasTimer: PropTypes.bool
};

export {
    DiscountBlock
};
